export * from './kunde-gespeichert.interface';
